import { ManholeDesiltingProgrammeUi } from "./Engi_Man_Desil_Prog_civil_Bro_30_6_2024";

const Engineering_Manhole_Desilting_Programme = () => (
  <ManholeDesiltingProgrammeUi
    firstList={[
      {
        fileStoreId: "e0968be3-4515-4870-93a2-6df92d5685ed",
        label: "Manhole desilting Br-I",
      },
      {
        fileStoreId: "f6bc738c-d02f-4f22-9cec-2afd4bff9864",
        label: "Manhole desilting Br-II",
      },
      {
        fileStoreId: "3d3cde69-99a0-459b-b239-9451d2f203e4",
        label: "Manhole desilting Br-III",
      },
      {
        fileStoreId: "249f2cd8-0046-42b4-af5d-b60cb084e42d",
        label: "Manhole desilting Br-IV",
      },
      {
        fileStoreId: "62ffc406-cd19-4c2e-aa61-6a9543538159",
        label: "Manhole desilting Br-V",
      },
      {
        fileStoreId: "026520e-88de-4f92-81e8-fc7a2fee3528",
        label: "Manhole desilting Br-VI",
      },
      {
        fileStoreId: "8a10ac03-87f3-4927-8474-906e4b9800bc",
        label: "Manhole desilting Br-VII",
      },
      {
        fileStoreId: "5991110d-286c-4dcb-aec6-86ca4e5a711e",
        label: "Manhole desilting Br-VIII",
      },
    ]}
    secondList={[
      {
        fileStoreId: "c421a7c3-f02f-461f-9f53-01ef625535a5",
        label: "Manhole desilting Br-IX",
      },
      {
        fileStoreId: "feaf2698-dc8f-4fcc-afa1-5e97f6818c58",
        label: "Manhole desilting Br-X",
      },
      {
        fileStoreId: "591cab08-0410-4079-928f-847e1bbbc9d6",
        label: "Manhole desilting Br-XI",
      },
      {
        fileStoreId: "6e736e96-cf6d-4b89-b51c-80a18b8970e2",
        label: "Manhole desilting Br-XII",
      },
      {
        fileStoreId: "db6a3b33-22fd-4616-9264-3e97d92eeeeb",
        label: "Manhole desilting Br-XIII",
      },
      {
        fileStoreId: "12a31279-4411-452d-bd5a-48088c9e5857",
        label: "Manhole desilting Br-XIV",
      },
      {
        fileStoreId: "4800ecc8-e8b2-47af-ae1e-fe91a7692944",
        label: "Manhole desilting Br-XV",
      },
      {
        fileStoreId: "c7b1c62c-4eb3-46c6-a00f-4a0e6e648faa",
        label: "Manhole desilting Br-XVI",
      },
    ]}
  />
);

export default Engineering_Manhole_Desilting_Programme;
